function disable_inputs() {
  $("input").prop("disabled", true);
  $("select").prop("disabled", true);
  $("button").prop("disabled", true);
  $("a").prop("disabled", true);
  $("i").prop("disabled", true);
  $("i").hide();
}

window.init_pre_datepicker = function(){
  $(".datepicker_pre").each(function () {
    idd = $(this).attr("id");
    $("#" + idd).datetimepicker({
      format: "MM/DD/YYYY",
      // useCurrent: false,
    });

    $("#" + idd).on("dp.change", function (e) {
      $(this).find("input")[0].click();
    });
  });

  $(".timepicker_pre").each(function () {
    idd = $(this).attr("id");
    $("#" + idd).datetimepicker({
      format: "LT",
    });
    $("#" + idd).on("dp.change", function (e) {
      $(this).find("input")[0].click();
    });
  });

}

window.init_decision_datepicker = function () {
  console.log('init dec datepicket js > init_decision_datepicker')
  if (window.openIntervals == undefined) {
    window.openIntervals = [];
  }
  if (window.hiddenIntervals == undefined) {
    window.hiddenIntervals = [];
  }
  function initialize_date_time() {
    console.log('init dec datepicket js > initialize_date_time');
    $(".datepicker").each(function () {
      idd = $(this).attr("id");
      $("#" + idd).datetimepicker({
        format: "MM/DD/YYYY",
        // useCurrent: false,
      });

      $("#" + idd).on("dp.change", function (e) {
        $(this).find("input")[0].click();
      });
    });

    $(".timepicker").each(function () {
      idd = $(this).attr("id");
      $("#" + idd).datetimepicker({
        format: "LT",
      });
      $("#" + idd).on("dp.change", function (e) {
        $(this).find("input")[0].click();
      });
    });
  }

  // $("span#time_left count-down h1").css('font-size', '15px')
  function clear_intervals() {
    // console.log(window.openIntervals)
    // for ( var i = window.openIntervals-100; i <= window.openIntervals; ++i ){
    //   clearInterval(i);
    // }
    for (var i = 0; i < window.openIntervals.length; ++i) {
      clearInterval(window.openIntervals[i]);
    }
    $("#time_left").text("");
    $("#time_left_student").text("");
  }

  var x = [];

  function timer_count() {
    clear_intervals();
    countdownval = $("#count_down_date").val();
    // console.log(countdownval);
    if (countdownval != "" || countdownval != undefined) {
      var countDownDate = new Date(countdownval).getTime();
      // console.log(countDownDate);
      var now = new Date($("#current_date").val()).getTime(); //new Date().getTime();
      window.openIntervals.push(
        setInterval(function () {
          now = now + 1000;
          // console.log(now);

          // var now = new Date().getTime();
          var distance = countDownDate - now;

          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          // console.log(days);
          var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) + days * 24
          );
          // console.log(hours);
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          hours = hours < 10 ? "0" + hours : hours;
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          if (!isNaN(seconds && seconds >= 0)) {
            $("#time_left").text(hours + ": " + minutes + ": " + seconds);
            $("#time_left_student").text(
              hours + ": " + minutes + ": " + seconds
            );
          }
          // If the count down is finished, write some text
          if (distance < 0) {
            clear_intervals();
            if ($("#time_left").html() != "Simulation Expired") {
              $("#time_left").text("Simulation Expired");
              $("#time_left_student").text("Simulation Expired");
              $("#decision_timeout").click();
            }
          }
        }, 1000)
      );
    } else {
      clear_intervals();
      $("#time_left").text("Simulation Expired");
      $("#time_left_student").text("Simulation Expired");
      // $('#decision_timeout').click();
    }
  } // end of timer function;

  function timer_count1() {
    clear_intervals();
    countdownval = $("#count_down_date").val();
    // console.log(countdownval);
    if (countdownval != "" || countdownval != undefined) {
      var countDownDate = new Date(countdownval).getTime();
      // console.log(countDownDate);
      var now = new Date($("#current_date").val()).getTime(); //new Date().getTime();
      window.openIntervals.push(
        setInterval(function () {
          now = now + 1000;
          // console.log(now);

          // var now = new Date().getTime();
          var distance = countDownDate - now;

          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          // console.log(days);
          var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) + days * 24
          );
          // console.log(hours);
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          hours = hours < 10 ? "0" + hours : hours;
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          if (!isNaN(seconds && seconds >= 0)) {
            $("#time_left").text(hours + ": " + minutes + ": " + seconds);
            $("#time_left_student").text(
              hours + ": " + minutes + ": " + seconds
            );
          }
          // If the count down is finished, write some text
          if (distance < 0) {
            clear_intervals();
            if ($("#time_left").html() != "Simulation Expired") {
              $("#time_left").text("Simulation Expired");
              $("#time_left_student").text("Simulation Expired");
              // $("#decision_timeout").click();
            }
          }
        }, 1000)
      );
    } else {
      clear_intervals();
      $("#time_left").text("Simulation Expired");
      $("#time_left_student").text("Simulation Expired");
      // $('#decision_timeout').click();
    }
  }

  if ($("#time_left").html() == "") {
    $.when(clear_intervals()).then(function () {
      timer_count();
      // var timer_int = setInterval(function(){
      //   if($('#time_left').text() == ''){
      //     timer_count();
      //   } else {
      //     clearInterval(timer_int);
      //   }
      // },2000)
      //setTimeout(timer_count,3000);
    });
  }

  function clear_hidden_intervals() {
    // Clear any existing intervals for the hidden span
    for (var i = 0; i < window.hiddenIntervals.length; ++i) {
      clearInterval(window.hiddenIntervals[i]);
    }
    $("#time_left_hidden").text("");
  }


  function hidden_timer_count1(countDownDate, now) {
          //now = now + 10000 //60000; // Update time every minute
    
        // console.log('init, now', init, now);
        // console.log(init, now);
        var distance = countDownDate - now;
    
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) + days * 24
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        if (!isNaN(seconds && seconds >= 0)) {
            $("#time_left_hidden").text(
               "Time left for submission "+ hours + "hours" + minutes + "minutes" + seconds + "seconds"
            );
            $("#time_left_hidden").attr("aria-live", "assertive");

            
        }
    
        if (distance < 0) {
            // clear_hidden_intervals();
            if ($("#time_left_hidden").html() != "Simulation Expired") {
                $("#time_left_hidden").text("Simulation Expired");
                $("#time_left_hidden").attr("aria-live", "assertive");
            }
        }    
      
    }
    
  function hidden_timer_count() {
    // clear_hidden_intervals();
    countdownval = $("#count_down_date").val();
    if (countdownval != "" || countdownval != undefined) {
        var countDownDate = new Date(countdownval).getTime();
        var now = new Date($("#current_date").val()).getTime();
        setTimeout(()=>{hidden_timer_count1(countDownDate, now)}, 3000); 
        // hidden_timer_count1();
        window.hiddenIntervals.push(
            setInterval(()=>{
              now = now + 60000;
              hidden_timer_count1(countDownDate, now)
            }, 60000) // Update every minute
        );
    } else {
        // clear_hidden_intervals();
        $("#time_left_hidden").text("Simulation Expired");
        $("#time_left_hidden").attr("aria-live", "assertive");
    }
}

if ($("#time_left_hidden").html() == "") {
    $.when(clear_hidden_intervals()).then(function () {
        hidden_timer_count();
    });
}

  initialize_date_time();
  timer_count1();

  $(".updateDeadlines").click(function () {
    setTimeout(function () {
      $.when(clear_intervals()).then(function () {
        timer_count();
      });
      initialize_date_time();
    }, 3000);
  });

  $(".timezone").change(function () {
    $(".timezone").prop("disabled", true);
    setTimeout(function () {
      $.when(clear_intervals()).then(function () {
        timer_count();
      });
      $(".timezone").prop("disabled", false);
      initialize_date_time();
    }, 3000);
  });

  $(".faq > ul > li > a").click(function () {
    if ($(this).next("div").hasClass("active")) {
      $(".faq ul li > div").hide();
      $(".faq ul li > div").removeClass("active");
    } else {
      $(".faq ul li > div").hide();
      $(".faq ul li > div").removeClass("active");
      $(this).next("div").toggle("slow");
      $(this).next("div").addClass("active");
    }
  });
};
